import { useContext, useMemo } from 'react';
import { defineMessages, useIntl } from '@alltrails/shared/react-intl';
import Select from '@alltrails/shared/denali/components/Select';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';

import CustomProvider from 'components/CustomProvider';
import LearnMore from '../LearnMore';
import { PrintContext } from '../../printContext';
import { scales } from '../../constants';

const SCALE_STRINGS = defineMessages({
  SCALE: { defaultMessage: 'Scale' },
  CONTENT: {
    defaultMessage:
      'Map scale expresses the relationship between a distance on the map and a distance on the ground. Map scale is shown as a ratio, like 1:5,000. In this example, 1 unit on the map = 5,000 of the same unit on the ground.'
  }
});

type Props = {
  isMobileWidth: boolean;
};

const Scale = ({ isMobileWidth }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { SCALE, CONTENT }
  } = useFormatMessage(SCALE_STRINGS);
  const intl = useIntl();
  const { scale, setScale } = useContext(PrintContext);

  const options = useMemo(() => Object.entries(scales(intl)).map(([value, label]) => ({ value, label })), []);
  return (
    <CustomProvider>
      <div className="scaleContainer">
        <Select
          labelText=""
          placeholder=""
          options={options}
          onChange={value => setScale(parseInt(value))}
          value={`${scale}`}
          testId="printpage-scale-select"
        />
      </div>
      <LearnMore title={SCALE} content={CONTENT} isMobileWidth={isMobileWidth} />
    </CustomProvider>
  );
};

export default Scale;
